import './index.sass';

export default () => {

  const initClickItem = () => {
    $('.button-like').find('.button-like__item').on('ajax:success', function(e, data) {
      e.stopPropagation();
      $(this).closest('.button-like').replaceWith(e.detail[0].html);
      initClickItem();
    });
  }
  initClickItem();
}